import { createStore } from "jotai";

import { resetSessionAtom } from "@/store/auth";

/**
 * 全局 jotai store
 * 与 main.tsx 中 JotaiProvider 共用同一实例，供 axios 拦截器等非 React 环境读写 atom
 */
export const jotaiStore = createStore();

/** 登录页 SPA 导航回调，由 App.tsx 在挂载时通过 bindLoginNavigation 注入 */
let navigateToLogin: ((redirectUrl?: string) => void) | null = null;

/**
 * 绑定登录页导航（避免 401 时使用 window.location 整页刷新）
 * @param handler 通常内部调用 router.navigate('/login?redirectUrl=...')
 */
export const bindLoginNavigation = (handler: (redirectUrl?: string) => void) => {
  navigateToLogin = handler;
};

/**
 * 统一会话登出：重置 jotai 鉴权状态 + 跳转登录页
 * 供 axios 401、手动退出等场景调用；与 resetSessionAtom 配合，不直接操作 localStorage 以外的业务 atom
 * @param redirectUrl 登录成功后希望回跳的路径，会拼到 query redirectUrl
 */
export const sessionLogout = (redirectUrl?: string) => {
  jotaiStore.set(resetSessionAtom);
  navigateToLogin?.(redirectUrl);
};
